import { render, staticRenderFns } from "./createLocal.vue?vue&type=template&id=62aa134d&scoped=true&"
import script from "./createLocal.vue?vue&type=script&lang=js&"
export * from "./createLocal.vue?vue&type=script&lang=js&"
import style0 from "./createLocal.vue?vue&type=style&index=0&id=62aa134d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62aa134d",
  null
  
)

export default component.exports